import { Component, OnInit, ViewEncapsulation, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatCheckboxChange, MatDialog } from "@angular/material";
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Router } from "@angular/router";
import { Validators,FormGroup, FormControl } from "@angular/forms";
import { SessionCheck, map_widthandheight, getCheckInExtent, LoadTechnologyFloorSvg, generateAlertMessage, AuthFailedMessage, getFeatureNeedtoShow } from "../../../../app-general";
import { map_creation, fillcolor_style, label_Polygon, get_geojsonObject_floor, mapTemplate_creation, mapBuildTemplate_creation } from '../../../../map-general';
import {getDeviceDetailsReq} from '../../technologyoverlay';
import { appsettings, fillcolorPolygon, enumRequestFrom, enumUIFeatureView, enumUIAction, enumUIView,NewDeviceTypeDesc,DeviceType,DeviceTypeDesc } from '../../../../app-settings';
import { getSubZone, getUnit, getSubZoneById } from '../../../../api';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { AddEditSubZone, DeleteSubZone } from '../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../../../api.service';
import { Subscription, Subject } from "rxjs";
import { Icon, Style, Fill, Stroke, Text } from 'ol/style';
import { GeneralMessageComponent } from '../../../../general-message/general-message.component';
import { ConfirmDialogComponent } from '../../../technologyoverlay/device/confirm-dialog/confirm-dialog.component';
import OlMap from 'ol/Map';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-managesub-zone',
  templateUrl: './managesub-zone.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./managesub-zone.component.scss']
})
export class ManagesubZoneComponent implements OnInit, OnDestroy {

  public addeditSubZoneForm: FormGroup;
  private _onDestroy: Subject<void> = new Subject<void>();
  selectedZoneName = "";
  watcher: Subscription;
  columns = 3;
  firstcolumns = 2;
  minheight = "350px";
  rowHeight = "79px";
  SubZoneInfo = [] as any[];
  selectedCampusId;
  selectedFloorId;
  SiteId = "1";
  Spacedetails;
  select_UnitIds = [];
  selectedData;
  selectZoneImageUrl;
  SubZonedetails;
  SubZoneName;
  SubZoneId = 0;
  selected_SpaceIds = [];
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  device_list_all = "3";
  FloorInfo;
  chkCampusvalue = true;
  chkCustomvalue = false;
  BuildNotifydefaultValue = 0;

  mapinfo = new OlMap();
  ImageUrl = "";
  BackgroundIMG = "Centrak";
  Check_ZoomLevel;
  Check_MapCenter;
  CZoomLevel;
  CRotateLevel;
  TranslateX;
  TranslateY;
  addfloorimageheight = 0;
  floorImageWidth=0;
  floorImageHeight=0;
  subZoneHeaderText = "Create Sub-Zone";
  
  constructor(private router: Router, mediaObserver: MediaObserver, public thisDialogRef: MatDialogRef<ManagesubZoneComponent>,@Inject(MAT_DIALOG_DATA) public data: any,@Inject(DOCUMENT) private document: any,
  private technologyoverlayService: TechnologyoverlayService,private apiService: ApiService, public dialog: MatDialog) {     
    this.selectedCampusId = data.subZonedata.CampusId;
    this.selectedFloorId = data.subZonedata.FloorId;
    this.selectedZoneName = data.subZonedata.FloorName + "," + data.buildName + "," + data.campusName;      
    this.SubZoneId = data.subZoneId;
    if(this.SubZoneId > 0)
    {
      this.subZoneHeaderText = "Edit/Delete Sub-Zone";
    }
    this.SubZoneName = data.subZoneName;        
    this.selectedData = data.subZonedata;
    this.floorImageWidth = data.floorImageWidth;
    this.floorImageHeight = data.floorImageHeight;
    this.selectZoneImageUrl = appsettings.FLOOR_IMAGE_FOLDER  + data.subZonedata.FloorPlanImage;         
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }       
      if (change) {        
        if (change.mqAlias == 'xs') {
          this.columns = 2;
          this.firstcolumns = 1; 
        }           
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;            
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 3;  
          this.firstcolumns = 2;            
        }               
        else
        {
          this.columns = 3;  
          this.firstcolumns = 2;              
        }    
      }
    });
    
  }  
  
  ngOnInit() {
    
    this.addeditSubZoneForm = new FormGroup({
      zoneName: new FormControl(""),
      subzoneName: new FormControl("", [Validators.required,Validators.maxLength(32),Validators.pattern(appsettings.Name_Pattern)]),
    });
    this.getDeviceDetails();
    this.getSubZonedetailsById();
          
  }
  
  public onCloseCancel = () => {
    this.thisDialogRef.close("Cancel");
    if (!SessionCheck(this.router)) {
      return;
    }
  };
  
  getSubZonedetailsById()
  {
    try
    {            
      let subZonedata: getSubZoneById = {
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        subZoneId: this.SubZoneId,       
      }
      this.technologyoverlayService.getSubZoneDetailsById(subZonedata).pipe(takeUntil(this._onDestroy))
          .subscribe((SubZonesinfo: any[]) => {  
          this.SubZonedetails = SubZonesinfo["apiReturn"];  
            if(SubZonesinfo["apiReturn"][0].Notifications == 0)
            {
              this.chkCampusvalue = true;
              this.chkCustomvalue = false;
            }
            else if(SubZonesinfo["apiReturn"][0].Notifications == 1)
            {
              this.chkCustomvalue = true;
              this.chkCampusvalue = false;
            }
        }); 
    }
    catch (err) 
    {
      throw new Error("managesub-zone.component.ts" +" - getSubZonedetails() - " +err.message);
    }
  }
  
  getSpaceDetailsById()
  {
    try
    {
      let voiceLicense = localStorage.getItem("voice_license");
      let unitid: getUnit = {
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        floorId: this.selectedFloorId,
        isIndoor:1,
        isNeedIntercom:parseInt(voiceLicense),
        isSubZone : 0
      }
      this.apiService.getUnitDetails(unitid).pipe(takeUntil(this._onDestroy))
          .subscribe((Unitsinfo: any[]) => {  
          this.Spacedetails = Unitsinfo["apiReturn"];      
          var floorId=this.selectedFloorId;
          var arr_layer = [];
          this.mapinfo.getLayers().forEach(function (Floorlayer) {
            if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" +floorId ) {
              arr_layer[arr_layer.length] = Floorlayer;
            }
          });
          
          console.log("getUnitDetails :" +JSON.stringify(this.Spacedetails));
          var _this = this;
          Unitsinfo["apiReturn"].forEach(row => {      
            if(row.SubZoneId > 0 && row.SubZoneId == this.SubZoneId)
            {
              row['isChecked'] = true;
              _this.select_UnitIds.push(row.UnitId);
              _this.ShowRoomLayer(arr_layer,row.UnitId,true);
            }
             else
              row['isChecked'] = false;
          });

          

        }); 

    }
    catch (err) 
    {
      throw new Error("managesub-zone.component.ts" +" - getSpaceDetailsById() - " +err.message);
    }
  }
  
handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.addeditSubZoneForm.controls).forEach(field => { // {1}
        const control = this.addeditSubZoneForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('managesub-zone.component.ts' + ' - handleInput() - ' + err.message);
    }
}
  


getDeviceDetails() {

  try {
    let voiceLicense = localStorage.getItem("voice_license");
    var devicedata:getDeviceDetailsReq = 
    { 
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId:parseInt(this.selectedCampusId),
      floorId: parseInt(this.selectedFloorId),
      status:  this.device_list_all,
      devicetype: 0,
      device: 0, 
      spaceId: 0,
      isIndoor:1,
      isNeedRoomonly:1,
      isNeedIntercom : parseInt(voiceLicense)
    };

    this.apiService.getDeviceDetails(devicedata).pipe(takeUntil(this._onDestroy))
      .subscribe((DeviceDetails: any[]) => {
        
        if (DeviceDetails != null && DeviceDetails != undefined) {
          if (DeviceDetails["apiReturn"] == "Invalid Auth Key") {
            AuthFailedMessage(this.dialog, this.router);
            return;
          }
          
          DeviceDetails["apiReturn"].forEach(function (e) {
            if (e.DeviceName == DeviceTypeDesc.Emitter) {
              e['NewDeviceName'] = NewDeviceTypeDesc.Emitter;
            }
            else if (e.DeviceName == DeviceTypeDesc.HRex) {
              e['NewDeviceName'] = NewDeviceTypeDesc.HRex;
            }
            else if (e.DeviceName == DeviceTypeDesc.Rex) {
              e['NewDeviceName'] = NewDeviceTypeDesc.Rex;
            }
            else if (e.DeviceName == DeviceTypeDesc.LF) {
              if (e.SubType==DeviceType.DripTray)
               {
                 e['NewDeviceName'] = NewDeviceTypeDesc.DripTray;
               }
               else
               {
              e['NewDeviceName'] = NewDeviceTypeDesc.LFExiter;
              }
            }
            else if (e.DeviceName == DeviceTypeDesc.Pullcord) {
              e['NewDeviceName'] = NewDeviceTypeDesc.Pullcord;
            }
            else if (e.DeviceName == DeviceTypeDesc.DC  || e.DeviceName == DeviceTypeDesc.NewDC) {
              e['NewDeviceName'] = NewDeviceTypeDesc.DC;
            }
            else if (e.DeviceName == DeviceTypeDesc.Monitor) {
              e['NewDeviceName'] = NewDeviceTypeDesc.Monitor;
            }
            else if (e.DeviceName == DeviceTypeDesc.VW) {
              e['NewDeviceName'] = NewDeviceTypeDesc.VW;
            }
            else if (e.DeviceName == DeviceTypeDesc.Gateway) {
              e['NewDeviceName'] = NewDeviceTypeDesc.Gateway;
            }
            else if (e.DeviceName == DeviceTypeDesc.UT) {
              e['NewDeviceName'] = NewDeviceTypeDesc.UT;
            }
            else if (e.DeviceName == DeviceTypeDesc.UM) {
              e['NewDeviceName'] = NewDeviceTypeDesc.UM;
            }
            else if (e.DeviceName == NewDeviceTypeDesc.Room) {
              e['NewDeviceName'] = NewDeviceTypeDesc.Room;
            }
            else if (e.DeviceName == DeviceTypeDesc.Intercom) {
              e['NewDeviceName'] = DeviceTypeDesc.Intercom;
            }
            else {
              e['NewDeviceName'] = NewDeviceTypeDesc.Zone;
            }
          })
          
          let DeviceList_array = [];
          DeviceDetails["apiReturn"].forEach(function (data) {
            if (data.FilterDeviceType != NewDeviceTypeDesc.Room) {
              var newData = {};
              newData['DeviceId'] = data.DeviceId;
              newData['DeviceTypeId'] = data.DeviceTypeId;
              newData['NewDeviceName'] = data.NewDeviceName;
              newData['UnitLocation'] = data.UnitLocation;
              newData['DataId'] = data.DataId;
              newData['UnitId'] = data.UnitId;
              newData['Description'] = data.Description;
              if (data.DeviceId > 0 || data.DeviceName == DeviceTypeDesc.Gateway)
                newData['Status'] = 'Active';
              else if (data.DeviceId == 0)
                newData['Status'] = 'Inactive';
              DeviceList_array.push(newData);
            }
          })
       
          this.FloorInfo = DeviceDetails["apiReturn"];            
          this.DrawFloorMapCall();     
          this.getSpaceDetailsById();           
        }
      });
  }
  catch (err) {
    throw new Error('device.component.ts' + ' - getDeviceDetails() - ' + err.message);
  }
}


  DrawFloorMapCall() {
    try {      
      var selectedfloor = this.selectedFloorId;
      var ImageWidth = this.floorImageWidth;  //7335.0
      var ImageHeight = this.floorImageHeight //5421.0 
      var CZoomLevel = 0
      var CRotateLevel = 0
      var TranslateX = 0
      var TranslateY = 0
      var FloorImageURL = this.selectedData.FloorPlanImage;

      var ImageUrl = appsettings.FLOOR_IMAGE_FOLDER + "/" + FloorImageURL;

      var BackgroundIMG = "";
      var Map_image_path = 'assets/images/';

      
      let element = this.document.getElementById('map');
      var IsZoomChanged = 0;
      if(element.innerHTML != "" && (this.Check_ZoomLevel || this.Check_ZoomLevel == 0))
      {
        this.CZoomLevel = this.Check_ZoomLevel;
        IsZoomChanged = 1;
      }
      else{
        this.Check_MapCenter = [];
      }
      element.innerHTML = '';

      let imgwh = map_widthandheight(ImageWidth, ImageHeight);
      var imgwidth = imgwh.ImageWidth;
      var imgheight = imgwh.ImageHeight;
      this.addfloorimageheight = imgwh.ImageHeight;

      // Polygons style
      var labelStyle = label_Polygon(0);
      var fillcolorStyle = fillcolor_style(fillcolorPolygon.Incomplete);
      var style = [fillcolorStyle, labelStyle];

      var devicelabelStyle = new Style({

        text: new Text({
          font: '10px Poppins, sans-serif',
          overflow: true,
          fill: new Fill({
            color: '#000'
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 5
          }),
          offsetX: 0,
          offsetY: 25.5
        })
      });


      var deviceStyle = fillcolor_style(fillcolorPolygon.Completed);

      var fillStyle = [deviceStyle, devicelabelStyle];
      CZoomLevel=.2;
      //var map = mapBuildTemplate_creation(ImageUrl, imgwidth, imgheight, true, BackgroundIMG, CZoomLevel, CRotateLevel, element.offsetWidth, element.offsetHeight, TranslateX, TranslateY, mapId);
      var map = map_creation(ImageUrl, imgwidth, imgheight, true, BackgroundIMG, CZoomLevel, CRotateLevel, element.offsetWidth, element.offsetHeight, TranslateX, TranslateY, 'map', this.Check_MapCenter, IsZoomChanged);

      map.getControls().removeAt(0)
      var translateX = TranslateX;
      var translateY = TranslateY;

      translateX = translateX / 122;
      translateY = translateY / 127;

      translateX = translateX * imgwidth;
      translateY = translateY * imgheight;

      var _map = map;
   
      var MapCenter = _map.getView().getCenter();

      MapCenter[0] -= translateX;
      MapCenter[1] += translateY;

      _map.on('moveend', function (e) {
        getCheckInExtent(e, _map, imgwidth, imgheight, MapCenter);
      });

      //////////Floor Devices Start////////////

      var arrdevicemarker = [];
      var arrdevicemarkernoPoly = [];
      if (this.FloorInfo != null) {
        /// Geo Feature Collection ///
        var geoFloorjsonObject = get_geojsonObject_floor(enumRequestFrom.floorplan_page);
        geoFloorjsonObject.type = "FeatureCollection";

        var arrgeoFloorjsonObject = geoFloorjsonObject.features; // empty Object
        geoFloorjsonObject.features.length = 0;

        /// marker array ///
        var arrmarker = [];
        if (this.FloorInfo.length > 0) {
          var arrFloorInfo = this.FloorInfo;
          LoadTechnologyFloorSvg(map, arrFloorInfo, imgheight, imgwidth, arrdevicemarker, geoFloorjsonObject, arrdevicemarkernoPoly, devicelabelStyle, fillStyle, Map_image_path, selectedfloor,0);
          this.mapinfo=map;
        }
        else if (FloorImageURL == null) {
          document.getElementById("map").innerHTML = "<span style='margin-top: 15%; padding-left: 45%;display:block;font-size:15px;font-weight:bold;'> Map Not Found.</span>";
        }
      }
      //////////Floor Devices End////////////

    }
    catch (err) {
      throw new Error('managesub-zone.component.ts - DrawFloorMapCall() - ' + err.message);
    }

  }
  
  togglefloorVisibility(checkedid, event: MatCheckboxChange) {
    
    var floorId=this.selectedFloorId;
    var arr_layer = [];
    this.mapinfo.getLayers().forEach(function (Floorlayer) {
      if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" + floorId) {
        arr_layer[arr_layer.length] = Floorlayer;
      }
    });


    if (event.checked) {
      const index = this.select_UnitIds.indexOf(checkedid);
      if (index == -1) {
        this.select_UnitIds.push(checkedid);
      }
    } else {
      const index = this.select_UnitIds.indexOf(checkedid);
      if (index >= 0) {
        this.select_UnitIds.splice(index, 1);
      }
    }    
    
    this.ShowRoomLayer(arr_layer,checkedid,event.checked )
   
  }
   
  ShowRoomLayer(arr_layer,checkedid,ischecked)
  {
    for (var indx = 0; indx < arr_layer.length; indx++) {
      var room_layer = arr_layer[indx].values_.name
      if (room_layer=='Room_' +checkedid) {
        if (ischecked == false)
        {
          arr_layer[indx].setVisible(false);
        }
        else
        {
          arr_layer[indx].setVisible(true);
        }
      }
    }
  }

  public saveSubZoneInfo = (subzoneFormValue) => {
    try 
    {
      var notificationvalue = 0;   
      if(this.addeditSubZoneForm.valid)
      {
        
        let saveclick = this.document.getElementById('btnzonetempsaveclick');
        saveclick.className = 'clssubzonesavebutton mat-raised-button disablebtn';  
        
        if(this.chkCampusvalue == false && this.chkCustomvalue == false)
        {
          generateAlertMessage(this.dialog, "Please Select Notifications");
          saveclick.className = 'clssubzonesavebutton mat-raised-button';                    
          return;
        }            
        
        
        if (this.select_UnitIds.length==0)
        {
          generateAlertMessage(this.dialog, 'Must add at least one Space to create as a new Sub-Zone'); 
          saveclick.className = 'clssubzonesavebutton mat-raised-button';  
          return ;
        }
        
        if(this.chkCampusvalue == true)  
            notificationvalue = 0;
        else
            notificationvalue = 1;
            
            let MessageDetail;
              
            var message = "";
            
             message = 'By selecting "Custom", you must now configure Subzones for this Zone. Truview will now build out the Subzone Notifications for each alert type.'                                                  
            
             if(notificationvalue == 1) 
             {
                MessageDetail = { Message: message, Type: 2, CustomType: 1 }
        
                let dialogRef = this.dialog.open(ConfirmDialogComponent, {
                  disableClose: true,
                  width: '650px',
                  height: '250px',
                  panelClass: 'myapp-no-padding-dialog',
                  autoFocus: false,
                  data: MessageDetail
                });
                dialogRef.afterClosed().subscribe(result => {
                    
                  if (result == 'Confirm') {                                          
                    this.updateSubZone(subzoneFormValue,notificationvalue);
                  }
                  else {                                      
                    saveclick.className = 'clssubzonesavebutton mat-raised-button';  
                    return;
                  }
                })  
            }  
            else
            {
              this.updateSubZone(subzoneFormValue,notificationvalue);
            }  
            
        
      }
      
    }
    catch (err) {
      throw new Error("managesub-zone.component.ts" +" - saveSubZoneInfo() - " +err.message);
    }
  }
  
  updateSubZone(subzoneFormValue,notificationvalue)
  {
    let saveclick = document.getElementById('btnzonetempsaveclick');
    
    let subzonedetails: AddEditSubZone = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId: this.selectedData.CampusId,
      buildId: this.selectedData.BuildId,
      zoneId: this.selectedFloorId,
      subZoneId: this.SubZoneId,
      subZoneName:subzoneFormValue.subzoneName.replace(/\s+/g, ' ').trim(),
      unitIds : this.select_UnitIds.toString(),
      notifications:parseInt(notificationvalue)           
    }
    
    this.technologyoverlayService.addSubZoneDetails(subzonedetails).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse: any[]) => {  
        if(apiresponse["apiReturn"].toString() == "Success" && this.SubZoneId == 0)               
        {
          generateAlertMessage(this.dialog, 'Sub-Zone added successfully.');
          this.thisDialogRef.close(this.selectedFloorId);
        }
        else if(apiresponse["apiReturn"].toString() == "Success" && this.SubZoneId > 0)               
        {
          generateAlertMessage(this.dialog, 'Sub-Zone edited successfully.');
          this.thisDialogRef.close(this.selectedFloorId);
        }
        else if(apiresponse["apiReturn"].toString() == "Fail")
        { 
          generateAlertMessage(this.dialog, 'Sub-Zone added failed.');	 
          saveclick.className = 'clseditunitbutton mat-raised-button';                 
          this.thisDialogRef.close();
        }              
        else if(apiresponse["apiReturn"] == "Invalid Auth Key")
        {    
            this.thisDialogRef.close('close');              
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        }
        else if(apiresponse["apiReturn"] == "Sub Zone name is Empty")
        {                
          generateAlertMessage(this.dialog, 'Please enter Space Name');                  
          saveclick.className = 'clssubzonesavebutton mat-raised-button'; 
          return; 
        }
        else
        { 
          generateAlertMessage(this.dialog, "Sub-Zone name '" + apiresponse["apiReturn"][0].SubZoneDesc + "' already exists.");
          saveclick.className = 'clssubzonesavebutton mat-raised-button';
        }
    }); 
  }
  
  openSubZoneDeletedialog() {     
    try
    {   
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }        
      this.deleteSubZonedetails(this.SubZoneId)
    }
    catch (err) {
          throw new Error('managesub-zone.component.ts' + ' - openSubZoneDeletedialog() - ' + err.message);
      }           
  }
  
  deleteSubZonedetails(deleteSubZoneId)
  {
    try
    {    
      console.log("DeviceInfo : " + this.Spacedetails.length)      
      
      var Space_Count="";
      var message="";      
          
      if(this.Spacedetails.length > 0)   
      {
          message = "It contains ";
          Space_Count = this.select_UnitIds.length + " Spaces.";
      }
      
      var GeneralMessageData = {
        General_header:  "Delete Sub-Zone ",                
        GeneralMessage:  "Are you sure you want to delete this Sub-Zone?",//<br> " + message + " <b>" + Space_Count + " </b>
        General_first:  "Yes ",
        General_second:  "No"
      }  
      
      let dialogRef = this.dialog.open(GeneralMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: GeneralMessageData
      });     
      
      dialogRef.afterClosed().subscribe(result => {     
        if(result == "First")
        {                     
            this.DeleteSpacebyId(deleteSubZoneId)         
        }
        else
        {                
          dialogRef.close('Cancel');          
          return;
        }
      });            
    }
    catch(err)
    {
        throw new Error('delete-resident-group.ts' + ' - deleteUnit() - ' + err.message);
    } 
  }
  
  DeleteSpacebyId(subzoneid)
  {
    var deleteunitById :DeleteSubZone = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      subZoneId: parseInt(subzoneid)
    }
    this.technologyoverlayService.deleteSubZone(deleteunitById).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : any[])=>{           
        if(apiresponse["apiReturn"].toString() == "Success")
        { 	
          generateAlertMessage(this.dialog, 'Sub-Zone deleted successfully.');                          
        } 
        else if(apiresponse["apiReturn"].toString() == "Fail")
        {
          generateAlertMessage(this.dialog, 'Sub-Zone deleted failed ');                    
        }
        else if(apiresponse["apiReturn"] == "Invalid Auth Key")
        {    
            this.thisDialogRef.close('close');              
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        }
        else
        {
          generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());                       
        } 
          this.thisDialogRef.close(subzoneid);          
      });
  }
  
  toggleCampusVisibility(event)
  {    
    if(event.checked == true)  
    {
      this.chkCustomvalue = false;
      this.chkCampusvalue = true;
    }
    else  
    {
      this.chkCampusvalue = false;
      this.chkCustomvalue = false;
    }
  }
  
  toggleCusVisibility(event)
  {
    this.BuildNotifydefaultValue = 0;
    if(event.checked == true)  
    {
      this.chkCustomvalue = true;
      this.chkCampusvalue = false;
    }
    else  
    {
      this.chkCampusvalue = false;
      this.chkCustomvalue = false;
    }
  }
  
  
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
